import { Card, Modal, message } from 'antd'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from "styled-components"
import moment from 'moment'
import SendForm from '@/components/SendNotification/SendForm'
import NotificationAPI from '@/API/notification'
import { withTranslation } from 'react-i18next';
import feeSvg from '../assets/image/fee.svg'
// import lockSvg from '../assets/image/lock-notification.svg'
import reStartPng from '../assets/image/restart.png'
import unlinkSvg from '../assets/image/unlink-notification.svg'
import lockPhoneSvg from '../assets/image/lock-phone.svg'
import unlockSvg from '../assets/image/unlock.svg'

const Container = styled.div`
  background-color:#f4f5f9;
  display:flex;
  flex-wrap: wrap;
`

const SendCard = styled(Card)`
  &.ant-card{
    margin:0 24px 24px 0;
  }
  width:260px;
  border-radius:4px !important;
  .ant-card-body{
    padding:0;
  }
`

const CenterDiv = styled.div`
  text-align:center;
  height:260px;
  font-size:16px;
  font-weight:bold;
  cursor: pointer;
`

const CardIcon = styled.img`
  margin:65px 0 35px;
  width:86px;
  height:86px;
`

const icons = [feeSvg, lockPhoneSvg, unlockSvg, unlinkSvg, reStartPng]
class SendNotification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDialog: false,
      type: null,
      file: null,
      confirmLoading: false,
      title: '',
      template: '',
      radioType: 1,
      singelValue: '',
      checkDate: moment().endOf('day'),     
      hidden:{display:'none'},
      titleIndex: ''
    };
  }
  handleClick = (index) => {
    const modalTypes = {
      0: 0,
      1: 2,
      2: 3,
      3: 4,
      4: 5
    }

    this.setState({ showDialog: true, type: modalTypes[index],singelValue:'', titleIndex: index }, () => {
      //如果是马来西亚运营编码    
      // if(!(this.props.operator === 'MYDG')){
      //   console.log(this.myInput);
      // }else{
        if (this.state.type < 3 || this.state.type === 4) {
          this.getTemplate()
        }
      // }
      
    })
  }
  handleCancel = () => {
    this.setState({ showDialog: false })
  }
  handleChange = (file) => {    
    this.setState({ file: file })
  }
  //点击发送指令确定按钮
  sendNotification = () => {
    //判断单选还是多选
    if (this.state.radioType) {
      //单选操作    
      if (this.state.singelValue === '') {
        return message.error(this.props.t('Please enter an IMEI'))
      }
      this.setState({ confirmLoading: true })
      //如果类型不是4,不需要传unbindTime
      let unbindTimeObj = {};
      if((this.state.type === 4)){     
        //判断是否选择当天，如果是把时间干掉，立即解绑
        if(moment(this.state.checkDate).format('YYYY-MM-DD')===moment().format('YYYY-MM-DD')){
          delete unbindTimeObj.unbindTime
        }else{
          unbindTimeObj.unbindTime = moment(this.state.checkDate).format('X')
        }        
      }else{
        delete unbindTimeObj.unbindTime
      }
      NotificationAPI.sendSingleNotification(Object.assign({},{'imei': this.state.singelValue, 'cmdType': this.state.type},unbindTimeObj)).then((res) => {
        if (!res.code) {
          this.setState({ showDialog: false })
          message.success(res.info)
        }
        this.setState({ confirmLoading: false })
      }).catch(() => {
        this.setState({ confirmLoading: false })
      })

    } else {
      //多选
      if (!this.state.file) {
        return message.error(this.props.t('Import IMEIs first.'))
      }
      // if((this.state.type<3||this.state.type==4)&&(!this.state.title||!this.state.template)){
      //   return message.error(this.props.t('Set notification content first.'))
      // }
      this.setState({ confirmLoading: true })
      let formData = new FormData()
      formData.append('file', this.state.file)
      formData.append('cmdType', this.state.type)
      NotificationAPI.sendNotification(formData).then((res) => {
        if (!res.code) {
          this.setState({ showDialog: false })
          message.success(res.info)
        }
        this.setState({ confirmLoading: false })
      }).catch(() => {
        this.setState({ confirmLoading: false })
      })
    }
  }
  //渲染弹出模板
  getTemplate = () => {
    this.setState({ loading: true })
    const types = [0, 4, 3, 2, 5]
    // let { type } = this.state
    
    NotificationAPI.getNotification({ type: types[this.state.titleIndex] }).then((res) => {
      if (!res.code) {
        this.setState({ title: res.data.notifyTitle, template: res.data.notifyContent })
      }
      this.setState({ loading: false })
    })
  }
  getRadioType = (index) => {
    this.setState({ radioType: index })
  }
  changeInput = (index) => {
    this.setState({ singelValue: index })
  }
  changeDate = (value) => {
    this.setState({ checkDate: value })
  }

  
  render() {
    const { showDialog, type, title, template, confirmLoading, checkDate, singelValue,hidden, titleIndex} = this.state;       
    const { operator,roleId} = this.props;
    const titles = [this.props.t('Payment Reminder'), this.props.t('Lock Phone'), this.props.t('Unlock Phone'), this.props.t('Unbind Contract'),  this.props.t('Enrollment Message'),]   
    //判断是否马来西亚运营编码 MYDG
    let userMessage;     
    if(operator === 'MYDG' || operator === 'MYUM' || operator === 'MYMM'){
      if(roleId === 9){        
        userMessage = (
          titles.map((title, index) => (        
            <SendCard bordered={false} onClick={() => { this.handleClick(index) }} key={title} style={index === 0 || index === 1 || index === 4 ? hidden : null}>
              <CenterDiv>
                <CardIcon src={icons[index]}></CardIcon>
                <div>{title}</div>
              </CenterDiv>
            </SendCard>
          ))
        )
      }else{
        userMessage = (
        titles.map((title, index) => (        
          <SendCard bordered={false} onClick={() => { this.handleClick(index) }} key={title} style={index === 0 || index === 1 ? hidden : null}>
            <CenterDiv>
              <CardIcon src={icons[index]}></CardIcon>
              <div>{title}</div>
            </CenterDiv>
          </SendCard>
        ))
      )
      }
      
    }else{ 
      userMessage = (
        titles.map((title, index) => (        
          <SendCard bordered={false} onClick={() => { this.handleClick(index) }} key={title}>
            <CenterDiv>
              <CardIcon src={icons[index]}></CardIcon>
              <div>{title}</div>
            </CenterDiv>
          </SendCard>
        ))
      )
    }



    return (
      <Container>       
        {userMessage}
        <Modal maskClosable={false} title={titles[titleIndex]} visible={showDialog} onCancel={this.handleCancel} onOk={this.sendNotification} confirmLoading={confirmLoading}>
          <SendForm defaultDate={checkDate} changeDate={this.changeDate} getRadioType={this.getRadioType} changeInput={this.changeInput} type={type} title={title} template={template} onChange={this.handleChange} singelValue={singelValue}
          ></SendForm>
        </Modal>
      </Container>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    operator: state.operator,
    roleId:state.roleId

  }
}
export default connect(mapStateToProps,null)(withTranslation()(SendNotification))
